import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { UzurvDirectivesModule } from '@uzurv/core';
import { CreateRandomSubstanceScreeningDialogComponent } from './create-random-substance-screening-dialog.component';

@NgModule({
  declarations: [CreateRandomSubstanceScreeningDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    UzurvDirectivesModule,
    MatIconModule,
    MatRadioModule
  ],
  exports: [CreateRandomSubstanceScreeningDialogComponent],
  entryComponents: [CreateRandomSubstanceScreeningDialogComponent]
})
export class CreateRandomSubstanceScreeningDialogModule {}
